import * as localForage from 'localforage';

import { createStore } from '@ngneat/elf';
import { withActiveId, withActiveIds, withEntities } from '@ngneat/elf-entities';
import {
    createRequestsCacheOperator, createRequestsStatusOperator, initializeAsPending,
    withRequestsCache, withRequestsStatus
} from '@ngneat/elf-requests';
import { persistState } from '@shared/third-party/persist-state/persist-state';

import { Company } from './company.interface';

export const store = createStore(
	{ name: 'company' },
	withEntities<Company, 'company_id'>({ idKey: 'company_id' }),
	withRequestsStatus<`company` | `company-${string}`>(initializeAsPending('company')),
	withRequestsCache<`company` | `company-${string}`>(),
	withActiveId(),
	withActiveIds()
);
export const trackCompanyRequestsStatus = createRequestsStatusOperator(store);
export const persist = persistState(store, {
	key: 'company',
	storage: localForage,
});
export const skipWhileCompanyCached = createRequestsCacheOperator(store);
